import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

interface InputProps {
  value: string;
  setValue(value: string): void;
  onBlur?(e: any): void;
  type?: 'password' | 'email' | 'number' | 'text';
  placeholder?: string;
  className?: string;
}

const PasswordInput = ({
  value,
  setValue,
  onBlur,
  placeholder,
  className,
}: InputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="relative w-full">
      <input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className={`${className} w-full px-4 py-2 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-primary border-1 border-primary`}
        placeholder={placeholder}
        onBlur={onBlur}
      />
      <button
        type="button"
        onClick={() => setShowPassword((prev) => !prev)}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
        tabIndex={-1}
      >
        {showPassword ? <FiEyeOff /> : <FiEye />}
      </button>
    </div>
  );
};

export const Input = ({
  value,
  setValue,
  onBlur,
  type = 'text',
  placeholder,
  className,
}: InputProps) => {
  if (type === 'password') {
    return (
      <PasswordInput
        value={value}
        setValue={setValue}
        placeholder={placeholder}
        className={className}
      />
    );
  }

  return (
    <input
      onBlur={onBlur}
      type={type}
      placeholder={placeholder}
      className={`${className} w-full px-4 py-2 border border-gray-200 rounded focus:outline-none focus:ring-1 focus:ring-primary border-1 border-primary`}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
};
